import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css";
import './index.css';
import './utils/axiosInterceptor'; // Import the interceptor
import App from './App';
import reportWebVitals from './reportWebVitals';
import { serviceWorkerRegister } from './notifications/serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />);
{/*<React.StrictMode>*/}{/*</React.StrictMode>*/}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegister();